/* NODE: vídeos inline mudos — o arquivo só é pedido quando o card chega perto da tela, toca só com 40% visível
   e é descarregado quando fica longe (libera rede, memória e decodificador no celular). Perf 2026-10-06. */
document.addEventListener('DOMContentLoaded', function () {
  var vids = document.querySelectorAll('video.video-stories__inline');
  if (!vids.length) return;
  var carregar = function (v) {
    if (!v.poster && v.dataset.ndPoster) v.poster = v.dataset.ndPoster;
    if (!v.getAttribute('src') && v.dataset.ndSrc) v.src = v.dataset.ndSrc;
  };
  var descarregar = function (v) { if (v.getAttribute('src')) { v.pause(); v.removeAttribute('src'); v.load(); } };
  var perto = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) carregar(e.target); else descarregar(e.target); });
  }, { rootMargin: '300px 300px' });
  var visivel = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.4) {
        carregar(v);
        if (v.paused) v.play().catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: [0, 0.4] });
  vids.forEach(function (v) { v.preload = 'none'; perto.observe(v); visivel.observe(v); });

  /* pré-carrega os cards até 300px além da borda visível do carrossel (o IO não enxerga além do overflow do pai) */
  var vizinhos = function (track) {
    var tr = track.getBoundingClientRect();
    track.querySelectorAll('video.video-stories__inline').forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (r.right > tr.left - 300 && r.left < tr.right + 300) carregar(v);
    });
  };
  var tracks = new Set();
  vids.forEach(function (v) { var t = v.closest('.video-stories__container, [data-nd-track]'); if (t) tracks.add(t); });
  tracks.forEach(function (t) {
    var tick = null;
    t.addEventListener('scroll', function () { if (tick) return; tick = requestAnimationFrame(function () { tick = null; vizinhos(t); }); }, { passive: true });
    new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) vizinhos(t); }); }, { rootMargin: '300px 0px' }).observe(t);
  });
});

/* NODE: clique no vídeo inline liga/desliga o som (sem abrir tela) */
document.addEventListener('click', function (e) {
  var v = e.target.closest && e.target.closest('video.video-stories__inline');
  if (!v) return;
  e.preventDefault();
  e.stopPropagation();
  var toggleSom = !v.muted;
  document.querySelectorAll('video.video-stories__inline').forEach(function (o) { o.muted = true; });
  v.muted = toggleSom;
  if (v.paused) v.play().catch(function () {});
}, true);

/* NODE: setas laterais do carrossel de vídeos */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.video-stories__container').forEach(function (track) {
    if (track.dataset.ndArrows) return;
    track.dataset.ndArrows = '1';
    var wrap = track.parentElement;
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    var mk = function (dir, cls) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vs-arrow ' + cls;
      b.setAttribute('aria-label', dir > 0 ? 'Next' : 'Previous');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 6 6 6-6 6"/></svg>';
      b.addEventListener('click', function () {
        var item = track.querySelector('.video-stories__item');
        var w = item ? item.getBoundingClientRect().width + 16 : 300;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      });
      return b;
    };
    var prev = mk(-1, 'vs-arrow--prev');
    var next = mk(1, 'vs-arrow--next');
    wrap.appendChild(prev);
    wrap.appendChild(next);
    var sync = function () {
      var has = track.scrollWidth - track.clientWidth > 8;
      prev.style.display = has ? '' : 'none';
      next.style.display = has ? '' : 'none';
    };
    sync();
    window.addEventListener('resize', sync);
  });
});
